import { axiosTemplate } from '../../axiosTemplate';
import * as qs from 'qs';
export const movHindcastManager = {
    endpoints: {
        test: `https://942x02n18l.execute-api.us-east-1.amazonaws.com/x/v0/rest`,
        acceptance: `https://fyjs10u72b.execute-api.us-east-1.amazonaws.com/x/v0/rest`,
        prod: `https://7sbg1v0f7b.execute-api.us-east-1.amazonaws.com/x/v0/rest`,
    },
    http: {
        getDatasets: ({ stage, metjwt, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).get(`${movHindcastManager.endpoints[stage]}/datasets`);
        },
        postTask: ({ stage, metjwt, task, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).post(`${movHindcastManager.endpoints[stage]}/tasks`, task);
        },
        getTasks: ({ stage, metjwt }) => {
            return axiosTemplate(metjwt).get(`${movHindcastManager.endpoints[stage]}/tasks`);
        },
        getNearestPoints: ({ stage, metjwt, lat, lon, datasetId, hindcastProviderId, cancelToken }) => {
            return axiosTemplate(metjwt).get(`${movHindcastManager.endpoints[stage]}/nearest-points?` + qs.stringify({ lat, lon, datasetId, hindcastProviderId }), {
                cancelToken,
            });
        },
        getPointStats: ({ stage, metjwt, lat, lon, datasetId, hindcastProviderId, cancelToken }) => {
            return axiosTemplate(metjwt).get(`${movHindcastManager.endpoints[stage]}/stats?` + qs.stringify({ lat, lon, datasetId, hindcastProviderId }), {
                cancelToken,
            });
        },
        postEnquiry: ({ stage, metjwt, task, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).post(`${movHindcastManager.endpoints[stage]}/enquiry`, task);
        },
    },
};
